var espresso = espresso || {},
    carpeople = carpeople || {};
( function () {
    'use strict';
    jQuery( function () {
        carpeople.init();
    } );
    carpeople.init = function () {
        carpeople.booking.init();
        carpeople.form.init();
        carpeople.mobility.init();
        //carpeople.redirect();
        carpeople.form.init();
    };
    carpeople.form = {
        init: function () {
            carpeople.form.callmeform();
            carpeople.form.topbanner();
        },
        callmeform: function () {
            jQuery('.js-cp-callmeform-workshop-select').on('change', function () {
                var jThis = jQuery(this),
                    strWorkshopName = jThis.find(':selected').data('workshopname');
                jQuery('.js-cp-callmeform-workshopname-hidden').val(strWorkshopName);
            });
        },
        topbanner: function () {
            if (jQuery.cookie('topBannerClosed') !== 'true') {
                jQuery('.js-cp-top-banner').removeClass('hidden');
            }
            jQuery('.js-cp-top-banner-close').on('click', function () {
                jQuery('.js-cp-top-banner').hide();
                jQuery.cookie('topBannerClosed', 'true', {
                    expires: 14
                });
            });
            jQuery('.js-btn-scroll-to-form').on('click', function () {
                jQuery(this).closest('.js-cp-top-banner').hide();
                jQuery('html, body').animate({
                    scrollTop: jQuery('form.js-call-me-workshop-form').offset().top -200
                }, 500);
            });

        }
    };
    carpeople.booking = {
        init: function () {
            carpeople.booking.scrollToServiceCalculator();
        },
        scrollToServiceCalculator: function () {
            jQuery( '.js-bookservice-servicelist-item[data-special="SERVICECALCULATOR"]' ).on( 'change', function () {
                if ( jQuery( this ).is( ':checked' ) === true ) {
                    setTimeout( function () {
                        jQuery( 'html, body' ).animate( {
                            scrollTop: jQuery( '.js-bookservice-panel-service-calculator' ).offset().top - 120
                        }, 500 );
                    }, 200 );
                }
            } );
        }
    };
    carpeople.form = {
        init: function () {
            carpeople.form.callmeform();
            carpeople.form.topbanner();
        },
        callmeform: function () {
            jQuery('.js-cp-callmeform-workshop-select').on('change', function () {
                var jThis = jQuery(this),
                    strWorkshopName = jThis.find(':selected').data('workshopname');
                jQuery('.js-cp-callmeform-workshopname-hidden').val(strWorkshopName);
            });
        },
        topbanner: function () {
            if (jQuery.cookie('topBannerClosed') !== 'true') {
                jQuery('.js-cp-top-banner').removeClass('hidden');
            }
            jQuery('.js-cp-top-banner-close').on('click', function () {
                jQuery('.js-cp-top-banner').hide();
                jQuery.cookie('topBannerClosed', 'true', {
                    expires: 14
                });
            });
            jQuery('.js-btn-scroll-to-form').on('click', function () {
                jQuery(this).closest('.js-cp-top-banner').hide();
                jQuery('html, body').animate({
                    scrollTop: jQuery('form.js-call-me-workshop-form').offset().top -200
                }, 500);
            });

        }
    };
    carpeople.booking = {
        init: function () {
            carpeople.booking.scrollToServiceCalculator();
        },
        scrollToServiceCalculator: function () {
            jQuery( '.js-bookservice-servicelist-item[data-special="SERVICECALCULATOR"]' ).on( 'change', function () {
                if ( jQuery( this ).is( ':checked' ) === true ) {
                    setTimeout( function () {
                        jQuery( 'html, body' ).animate( {
                            scrollTop: jQuery( '.js-bookservice-panel-service-calculator' ).offset().top - 120
                        }, 500 );
                    }, 200 );
                }
            } );
        }
    };
    carpeople.mobility = {
        init: function () {
            if ( jQuery( '.js-cp-mobility-code-container' ).length > 0 ) {
                carpeople.mobility.handlebars.get();
                carpeople.mobility.bindEvents();
            }
        },
        bindEvents: function () {
            jQuery( '.js-cp-mobility-code-container' ).validate( {
                submitHandler: function ( form ) {
                    carpeople.mobility.data.post( form, false );
                }
            } );
            jQuery( '.js-cp-mobility-signup-container' ).on( 'keydown keyup change', '.js-mobility-car-reg', function ( event ) {
                if ( event.which === 9 || event.which === 13 || event.type === 'change' || ( event.type === 'keyup' && jQuery( this ).val().replace( /\s/g, '' ).length === master.settings.licenseplate.length ) ) {
                    var jValue = jQuery( this ).val().replace( /\s/g, '' );
                    if ( jValue ) {
                        jQuery( this ).trigger( 'blur' );
                        jQuery.ajax( {
                            url: master.data.serviceCalendar.endpoint,
                            type: 'POST',
                            data: {
                                'action': master.data.serviceCalendar.actions.getvehicle,
                                'licenseplate': jValue
                            },
                        } ).done( function ( data ) {
                            var licenseData = data.Data;
                            //console.log(licenseData);
                            if ( licenseData.Registreringsnummer !== null ) {
                                jQuery.each( licenseData, function ( index, val ) {
                                    if ( val !== null ) {
                                        jQuery( master.licenseplate.selectors.info ).show().find( master.licenseplate.selectors.info + '-item[data-item="' + index + '"]' ).text( val.toString().toLowerCase() );
                                    }
                                } );
                                jQuery( 'input[name="CarTypeName"]' ).val( licenseData.Fabrikattekst + ' ' + licenseData.Modeltekst );
                                jQuery( '.js-module-licenseplate-info-icon' ).show();
                            }
                            else {
                                jQuery( 'input[name="CarTypeName"]' ).val( licenseData.ResponseResult.Text );
                            }
                        } );
                    }
                }
            } );
        },
        handlebars: {
            formTmpl: null,
            get: function () {
                jQuery.getScript( '//cdnjs.cloudflare.com/ajax/libs/handlebars.js/4.0.5/handlebars.min.js', function () {
                    carpeople.mobility.handlebars.compileTemplate();
                } );
            },
            compileTemplate: function () {
                var formTmpl = jQuery( '#js-cp-mobility-user-form-template' ).html();
                carpeople.mobility.handlebars.formTmpl = Handlebars.compile( formTmpl );
            }
        },
        data: {
            post: function ( form, user ) {
                var jLoader = jQuery( form ).parent().find( '.js-cp-mobility-loader' );
                jQuery( form ).parent().find( '.js-cp-mobility-feedback-success' ).hide();
                jQuery( form ).parent().find( '.js-cp-mobility-feedback-error' ).hide();
                jQuery.ajax( {
                    url: jQuery( form ).attr( 'action' ),
                    type: 'POST',
                    beforeSend: function () {
                        jLoader.addClass( 'loading' );
                    },
                    data: jQuery( form ).serialize(),
                } ).done( function ( data ) {
                    setTimeout( function () {
                        jLoader.removeClass( 'loading' );
                        if ( user === false ) {
                            if ( data.Success === 'True' ) {
                                carpeople.mobility.data.success( form, data, user );
                            }
                            else {
                                carpeople.mobility.data.error( form, user );
                            }
                        }
                        else {
                            if ( data.Success === 'True' ) {
                                carpeople.mobility.data.success( form, user );
                            }
                            else {
                                carpeople.mobility.data.error( form, user );
                            }
                        }
                    }, 1000 );
                } ).fail( function () {
                    jLoader.removeClass( 'loading' );
                    carpeople.mobility.data.error( form, user );
                } );
            },
            success: function ( form, data, user ) {
                if (user === false) {
                    var workshopArr = JSON.parse( sessionStorage.UserManagementAddresses );
                    data.workshops = workshopArr.sort( function ( a, b ) {
                        var x = a[ 'City' ],
                            y = b[ 'City' ];
                        return ( ( x < y ) ? -1 : ( ( x > y ) ? 1 : 0 ) );
                    } );
                }
                //console.log( data );
                jQuery( form ).parent().find( '.js-cp-mobility-feedback-success' ).fadeIn( 'fast', function () {
                    if ( user === false ) {
                        jQuery( '.cp-mobility-code-container, .js-cp-mobility-intro' ).slideUp( 'fast', function () {
                            jQuery( '.js-cp-mobility-after' ).slideDown( 'fast' );
                            jQuery( '.js-cp-mobility-signup-container' ).html( carpeople.mobility.handlebars.formTmpl( data ) ).slideDown( 'fast', function () {
                                carpeople.mobility.signup.init();
                                setTimeout( function () {
                                    jQuery( '.js-cp-mobility-feedback-success-inner' ).fadeOut( 'fast' );
                                }, 3000 );
                            } );
                        } );
                    }
                    else {
                        jQuery( '.js-cp-mobility-after' ).fadeOut( 'fast', function () {
                            jQuery( form ).parent().find( '.js-cp-mobility-signup-form' ).slideUp( 'fast' );
                            jQuery( '.js-cp-mobility-confirm-text' ).fadeIn( 'fast' );
                        } );
                    }
                } );
            },
            error: function ( form ) {
                jQuery( form ).parent().find( '.js-cp-mobility-feedback-error' ).show();
            }
        },
        signup: {
            init: function () {
                carpeople.mobility.signup.bindEvents();
                carpeople.mobility.signup.datePicker();
            },
            bindEvents: function () {
                jQuery( '.js-cp-mobility-signup-container' ).find( '.js-cp-mobility-signup-form' ).validate( {
                    submitHandler: function ( form ) {
                        carpeople.mobility.data.post( form, true );
                    }
                } );
            },
            datePicker: function () {
                jQuery.fn.datepicker.dates.da = {
                    days: [ 'Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag' ],
                    daysShort: [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ],
                    daysMin: [ 'Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø' ],
                    months: [ 'Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December' ],
                    monthsShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
                    today: 'I dag',
                    clear: 'Nulstil',
                    format: 'dd-mm-yyyy',
                    titleFormat: 'MM yyyy',
                    weekStart: 1
                };
                jQuery( '.js-cp-mobility-signup-container' ).find( '.js-cp-mobility-datepicker' ).datepicker( {
                    container: '.js-cp-mobility-datepicker',
                    format: 'dd-mm-yyyy',
                    toggleActive: false,
                    todayHighlight: true,
                    calendarWeeks: true,
                    maxViewMode: 0,
                    language: 'da',
                    daysOfWeekDisabled: '0,6',
                    autoclose: true
                } );
            }
        },
    };
    carpeople.redirect = function () {
        if ( co3.util.param.rdr ) {
            location.href = co3.util.param.rdr;
        }
    };
    espresso.maps.load = function () {
        var jGoogleMaps = jQuery( '.e-google-map' );
        var jSearchMarkerSettings = jQuery( '#js-e-maps-search-marker-settings' );
        if ( jGoogleMaps.length > 0 ) {
            jGoogleMaps.each( function ( index, element ) {
                var jGoogleMap = jQuery( element );
                // Save map settings on Map object
                jGoogleMap.data( 'settings', {
                    mapData: jGoogleMap.find( 'code.e-google-map-data' ),
                    mapZoom: ( jGoogleMap.data( 'zoom' ) !== undefined ? jGoogleMap.data( 'zoom' ) : 10 ),
                    mapRatio: window.outerWidth < 460 ? ( jGoogleMap.data( 'ratio' ) !== undefined ? jGoogleMap.data( 'mobile-ratio' ).split( ':' ) : '' ) : ( jGoogleMap.data( 'ratio' ) !== undefined ? jGoogleMap.data( 'ratio' ).split( ':' ) : '' ),
                    mapColor: co3.util.rgb2hex( ( jGoogleMap.data( 'color' ) !== undefined ? jGoogleMap.data( 'color' ) : jGoogleMap.css( 'color' ) ) ).replace( /^\#/, '' ),
                    mapDefaultMarkerColor: co3.util.rgb2hex( ( jGoogleMap.find( 'code.e-google-map-data' ).first().css( 'color' ) !== undefined ? jGoogleMap.find( 'code.e-google-map-data' ).first().css( 'color' ) : jGoogleMap.css( 'color' ) ) ).replace( /^\#/, '' ),
                    mapSearchIconColor: ( jSearchMarkerSettings.length > 0 ? co3.util.rgb2hex( jSearchMarkerSettings.css( 'color' ) ).replace( /^\#/, '' ) : '' ),
                    mapMaxZoomLevel: ( jGoogleMap.data( 'max-zoom-level' ) !== undefined ? jGoogleMap.data( 'max-zoom-level' ) : 12 ),
                    mapMinSearchRadius: ( jGoogleMap.data( 'min-search-radius' ) !== undefined ? jGoogleMap.data( 'min-search-radius' ) : 20 )
                } );
                if ( jGoogleMap.data( 'settings' ).mapRatio !== '' && jGoogleMap.data( 'settings' ).mapRatio.length === 2 ) {
                    jGoogleMap.css( 'padding-bottom', ( parseInt( jGoogleMap.data( 'settings' ).mapRatio[ 1 ] ) / parseInt( jGoogleMap.data( 'settings' ).mapRatio[ 0 ] ) * 100 ) + '%' );
                }
                var mapOptions = {
                    center: new google.maps.LatLng( 56.26392, 9.501785 ), //DK
                    scrollwheel: false,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    mapTypeControl: false,
                    zoom: jGoogleMap.data( 'settings' ).mapZoom,
                    backgroundColor: '#eeeeee',
                    styles: [ {
                        stylers: [ {
                            saturation: -100
                        } ]
                    }, {
                        'featureType': 'administrative',
                        'elementType': 'all',
                        'stylers': [ {
                            'saturation': '-100'
                        } ]
                    }, {
                        'featureType': 'administrative.province',
                        'elementType': 'all',
                        'stylers': [ {
                            'visibility': 'off'
                        } ]
                    }, {
                        'featureType': 'landscape',
                        'elementType': 'all',
                        'stylers': [ {
                            'saturation': -100
                        }, {
                            'lightness': 65
                        }, {
                            'visibility': 'on'
                        } ]
                    }, {
                        'featureType': 'poi',
                        'elementType': 'all',
                        'stylers': [ {
                            'saturation': -100
                        }, {
                            'lightness': '50'
                        }, {
                            'visibility': 'simplified'
                        } ]
                    }, {
                        'featureType': 'road',
                        'elementType': 'all',
                        'stylers': [ {
                            'saturation': '-100'
                        } ]
                    }, {
                        'featureType': 'road.highway',
                        'elementType': 'all',
                        'stylers': [ {
                            'visibility': 'simplified'
                        } ]
                    }, {
                        'featureType': 'road.arterial',
                        'elementType': 'all',
                        'stylers': [ {
                            'lightness': '30'
                        } ]
                    }, {
                        'featureType': 'road.local',
                        'elementType': 'all',
                        'stylers': [ {
                            'lightness': '40'
                        } ]
                    }, {
                        'featureType': 'transit',
                        'elementType': 'all',
                        'stylers': [ {
                            'saturation': -100
                        }, {
                            'visibility': 'simplified'
                        } ]
                    }, {
                        'featureType': 'water',
                        'elementType': 'geometry',
                        'stylers': [ {
                            'hue': '#ffff00'
                        }, {
                            'lightness': -25
                        }, {
                            'saturation': -97
                        } ]
                    }, {
                        'featureType': 'water',
                        'elementType': 'labels',
                        'stylers': [ {
                            'lightness': -25
                        }, {
                            'saturation': -100
                        } ]
                    } ]
                };
                jGoogleMap.gmap( mapOptions ).bind( 'init', function () {
                    if ( jGoogleMap.is( '#js-e-map' ) === true ) {
                        jGoogleMap.gmap( 'microdata', 'http://schema.org/Organization', function ( result, item, index ) {
                            espresso.maps.helpers.addMicroDataMarkers( result, item, index, jGoogleMap );
                        } );
                        // Init dealer search
                        espresso.dealersearch.init();
                    }
                    else {
                        //Add single marker
                        var addr = jQuery( jGoogleMap.data( 'settings' ).mapData ).text();
                        addr = decodeURIComponent( addr.replace( /^http:\/\//, '' ).replace( /[\(zoom,ratio=:0-9\)\s\%]+$/i, '' ) );
                        espresso.maps.helpers.addAddressMarker( jGoogleMap, addr );
                    }
                } );
            } );
        }
    };
    espresso.maps.helpers.icon = function ( type ) {
        var icons = {
            standard: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/carpeople-map-marker.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: false,
                name: ''
            },
            webshopBooking: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/carpeople-map-marker-webshop-booking.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: true,
                name: 'Webshop / Book tid online'
            },
            webshop: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/carpeople-map-marker-webshop.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: true,
                name: 'Webshop'
            },
            booking: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/carpeople-map-marker-booking.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: true,
                name: 'Book tid online'
            },
            selected: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/carpeople-map-marker-selected.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: false,
                name: ''
            }
        };
        if ( type === undefined ) {
            return icons;
        }
        else {
            return icons[ type ];
        }
    };
}() );

/* Google Maps Api key */
master.settings.maps.apiKey = 'AIzaSyCnijwTO9WMAIS8oQ5ADgpFLSbYKV2aza8';

// when user clicks on accept terms the checkboxes auto checks
(function () {
	var acceptedTop = $('#EcomOrderCustomerAcceptedTop');
	var acceptedBottom = $('#EcomOrderCustomerAccepted');

	if (acceptedTop.length && acceptedBottom.length) {
		var acceptTermsBtn = $('#accept-terms-btn');
		acceptTermsBtn.click(function () {
			acceptedBottom.prop("checked", true);
			acceptedTop.prop("checked", true);
		});
	}
})();


// facebook pixel tracking
(function () {
    var isReceiptPage = document.querySelector('.js-fb-pixel-data') !== null ? true : false;

    if (isReceiptPage) {
        var priceTotal = document.querySelector('.js-fb-tracking-total').textContent;
        var currency = document.querySelector('.js-fb-tracking-currency').textContent;
        
        fbq('track', 'Purchase', { value: priceTotal, currency: currency });
    }
})();
